'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _cartImage = require('../../components/generic/image-handling/cart-image');

var _cartImage2 = _interopRequireDefault(_cartImage);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderDetail = function (_React$Component) {
    _inherits(OrderDetail, _React$Component);

    function OrderDetail() {
        _classCallCheck(this, OrderDetail);

        return _possibleConstructorReturn(this, (OrderDetail.__proto__ || Object.getPrototypeOf(OrderDetail)).apply(this, arguments));
    }

    _createClass(OrderDetail, [{
        key: 'getActualItem',
        value: function getActualItem(itemObjectId) {
            return this.props.itemDetails.find(function (itemDetail) {
                return itemDetail.objectId === itemObjectId;
            });
        }
    }, {
        key: 'generateChosenOptionsList',
        value: function generateChosenOptionsList(chosenOptions, options) {
            var res = chosenOptions.map(function (cOption) {
                var key = cOption.optionCategoryName;
                var idx = _lodash2.default.findIndex(options, function (option) {
                    return option.category.trim() == key.trim();
                });

                var coKeyVal = cOption.selectedKeys.reduce(function (acc, key) {
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                }, {});

                return Object.keys(coKeyVal).map(function (key, i) {
                    var price = "";
                    var optionPrefix = "";
                    if (options[idx][key] !== 0) {
                        price = '$' + options[idx][key];
                    }

                    if (coKeyVal[key] > 1) {
                        optionPrefix = ' - ' + coKeyVal[key] + ' x ';
                    }

                    return _react2.default.createElement(
                        'li',
                        { key: key + '-' + i + '-' + idx, className: 'small' },
                        key,
                        optionPrefix,
                        price
                    );
                });
            });
            return _react2.default.createElement(
                'ul',
                { className: 'list-unstyled' },
                res
            );
        }
    }, {
        key: 'generateChosenOptionsListNew',
        value: function generateChosenOptionsListNew(chosenOptions) {

            var res = chosenOptions.map(function (cOption) {
                var coKeyVal = cOption.selectedKeys.reduce(function (acc, key) {
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                }, {});

                return Object.keys(coKeyVal).map(function (key, i) {
                    var optionPrefix = "";

                    if (coKeyVal[key] > 1) {
                        optionPrefix = coKeyVal[key] + ' x ';
                    }

                    return _react2.default.createElement(
                        'li',
                        { key: key + '-' + i + '-' + coKeyVal[key], className: 'small' },
                        optionPrefix,
                        key
                    );
                });
            });

            return _react2.default.createElement(
                'ul',
                { className: 'list-unstyled' },
                res
            );
        }
    }, {
        key: 'getCouponStructure',
        value: function getCouponStructure(order) {
            var couponInfo = order.couponInfo;
            if (couponInfo && !Utils.isEmptyObj(couponInfo)) {
                var component = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        { className: 'disc-highlight' },
                        'Applied coupon ',
                        _react2.default.createElement(
                            'b',
                            null,
                            couponInfo.couponCode
                        ),
                        ' for this order.'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        null,
                        'sub total ',
                        _react2.default.createElement(
                            'b',
                            { className: 'pull-right' },
                            ' $',
                            Utils.toRoundStr(order.subTotal, 2)
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'disc-highlight' },
                        'Discount ',
                        _react2.default.createElement(
                            'b',
                            { className: 'pull-right' },
                            ' -$',
                            Number(couponInfo.discountAmount).toFixed(2)
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Discounted sub total ',
                        _react2.default.createElement(
                            'b',
                            { className: 'pull-right' },
                            ' $',
                            Number(order.subTotal - couponInfo.discountAmount).toFixed(2)
                        )
                    )
                );
                return component;
            } else {
                return _react2.default.createElement(
                    'p',
                    null,
                    'sub total ',
                    _react2.default.createElement(
                        'b',
                        { className: 'pull-right' },
                        ' $',
                        Utils.toRoundStr(order.subTotal, 2)
                    )
                );
            }
        }
    }, {
        key: 'getDeliveryFeeStructure',
        value: function getDeliveryFeeStructure(order) {
            var component = null;

            if (order.deliveryFee) {
                component = _react2.default.createElement(
                    'p',
                    null,
                    'delivery fee',
                    _react2.default.createElement(
                        'b',
                        { className: 'pull-right' },
                        '$',
                        Utils.toRoundStr(order.deliveryFee, 2)
                    )
                );
            }

            return component;
        }
    }, {
        key: 'getServiceFeeStructure',
        value: function getServiceFeeStructure(order) {
            var component = null;

            if (order.serviceFee) {
                component = _react2.default.createElement(
                    'p',
                    null,
                    'service fee',
                    _react2.default.createElement(
                        'b',
                        { className: 'pull-right' },
                        '$',
                        Utils.toRoundStr(order.serviceFee, 2)
                    )
                );
            }

            return component;
        }
    }, {
        key: 'getDriverTipStructure',
        value: function getDriverTipStructure(order) {
            var component = null;
            if (order.tipAmount) {
                component = _react2.default.createElement(
                    'p',
                    null,
                    'tip',
                    _react2.default.createElement(
                        'b',
                        { className: 'pull-right' },
                        '$',
                        _lodash2.default.round(order.tipAmount || 0, 2).toFixed(2)
                    )
                );
            }
            return component;
        }
    }, {
        key: 'getCustomChargeStructureOfOptional',
        value: function getCustomChargeStructureOfOptional(order) {

            var customCharges = order.charge;
            if (customCharges != undefined && customCharges.length > 0) {

                return customCharges.map(function (charge, index, array) {

                    var component = null;

                    if (charge.type == "O" && !Utils.isEmpty(charge.optionName)) {
                        component = _react2.default.createElement(
                            'div',
                            { key: index, className: ' optional-charge-view' },
                            _react2.default.createElement(
                                'strong',
                                null,
                                charge.name
                            ),
                            ' : ',
                            charge.optionName
                        );
                    }
                    return component;
                });
            }
        }
    }, {
        key: 'getCustomChargeStructure',
        value: function getCustomChargeStructure(order) {

            var customCharges = order.charge;
            if (customCharges != undefined && customCharges.length > 0) {

                return customCharges.map(function (charge, index, array) {

                    var descComponent = null;
                    var chargeDescription = "";

                    if (!Utils.isEmpty(charge.typeDetailsName)) {
                        chargeDescription = charge.typeDetailsName;
                    } else if (!Utils.isEmpty(charge.desc)) {
                        chargeDescription = charge.desc;
                    } else {
                        chargeDescription = "";
                    }

                    if (!Utils.isEmpty(chargeDescription)) {
                        descComponent = _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(
                                'a',
                                { 'data-tip': chargeDescription, className: 'color-styl tooltip-button',
                                    style: { cursor: 'pointer' } },
                                _react2.default.createElement('i', {
                                    className: 'fa fa-info-circle'
                                })
                            ),
                            _react2.default.createElement(_reactTooltip2.default, { place: 'right', wrapper: 'span' })
                        );
                    }

                    return _react2.default.createElement(
                        'p',
                        { key: index },
                        charge.name,
                        ' ',
                        descComponent,
                        _react2.default.createElement(
                            'b',
                            {
                                className: 'pull-right' },
                            '$',
                            Utils.toRoundStr(charge.fee, 2)
                        )
                    );
                });
            }
        }
    }, {
        key: 'getItemInstructions',
        value: function getItemInstructions(itemOrderInst) {
            if (Utils.isEmpty(itemOrderInst)) {
                return null;
            }

            return _react2.default.createElement(
                'ul',
                { className: 'list-unstyled' },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Instructions: '
                    ),
                    '' + itemOrderInst
                )
            );
        }
    }, {
        key: 'renderOrderRow',
        value: function renderOrderRow() {
            var self = this;
            return this.props.order.items.map(function (item, index, array) {

                var actualItem = self.getActualItem(item.itemObjectId);
                var link = "";

                if (actualItem && actualItem.mediaArray && actualItem.mediaArray.length > 0) {
                    link = actualItem.mediaArray[0].url;
                }

                return _react2.default.createElement(
                    'tr',
                    { key: item.itemObjectId + index },
                    _react2.default.createElement(
                        'td',
                        { className: 'col-xs-10', style: { textAlign: "left" } },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'h4',
                                { className: 'item-in-cart' },
                                item.itemName
                            ),
                            _react2.default.createElement(
                                'h5',
                                null,
                                ' Qty: ',
                                item.itemQty,
                                ' x $',
                                item.itemPrice
                            ),
                            self.generateChosenOptionsListNew(item.itemOptionCategories),
                            self.getItemInstructions(item.itemOrderInst)
                        )
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'col-xs-2 text-center', style: { paddingTop: 20 } },
                        _react2.default.createElement(
                            'strong',
                            null,
                            '$',
                            item.itemQtyPrice ? Utils.toRoundStr(item.itemQtyPrice, 2) : Utils.toRoundStr(item.itemPrice * item.itemQty, 2)
                        )
                    )
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var order = this.props.order;
            return _react2.default.createElement(
                'div',
                { className: 'section order-success-pg' },
                _react2.default.createElement(
                    'div',
                    { className: 'container', style: { maxWidth: '100%' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12 text-center' },
                            _react2.default.createElement(
                                'h3',
                                { className: "order-heading2" },
                                'Order Details'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 col-md-12' },
                            _react2.default.createElement(
                                'table',
                                { className: 'table table-hover table-fixed' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement('tr', null)
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    this.renderOrderRow()
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'container', style: { maxWidth: '100%' } },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'cart_border' },
                                        this.getCustomChargeStructureOfOptional(order),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col-sm-offset-5 col-sm-7' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'cart_right' },
                                                this.getCouponStructure(order),
                                                this.getDeliveryFeeStructure(order),
                                                _react2.default.createElement(
                                                    'p',
                                                    null,
                                                    'Tax ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        { className: 'pull-right' },
                                                        ' $',
                                                        Utils.toRoundStr(order.taxes, 2)
                                                    )
                                                ),
                                                this.getServiceFeeStructure(order),
                                                this.getDriverTipStructure(order),
                                                this.getCustomChargeStructure(order)
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'cart_total' },
                                                _react2.default.createElement(
                                                    'h4',
                                                    null,
                                                    'Total',
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'pull-right' },
                                                        ' $',
                                                        Utils.toRoundStr(order.totalAmount, 2)
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return OrderDetail;
}(_react2.default.Component);

exports.default = OrderDetail;


//////////////////
// WEBPACK FOOTER
// ./src/components/order/OrderDetail.jsx
// module id = 548
// module chunks = 0